import bishop from "../../standardChess/MoveLogic/bishop.js";
import king from "./king";
import knight from "../../standardChess/MoveLogic/knight";
import pawn from "../../standardChess/MoveLogic/pawn";
import queen from "../../standardChess/MoveLogic/queen";
import rook from "../../standardChess/MoveLogic/rook";

const pieceMoves = {
  bishop,
  king,
  knight,
  pawn,
  queen,
  rook,
}

export default pieceMoves;